import { memo, useCallback } from 'react'
import { useAppSelector } from 'states/hooks'
import { GlobalMenuTaskDisplayModeButtonGroup } from 'enums/app'
import { TaskTable } from './components/taskTable/taskTable'
import { TaskCalendar } from './components/taskCalendar/taskCalendar'

export const TaskListPanel = memo(() => {
  // 選択中のタスクリスト表示モードを取得
  const selectedTaskListDisplayMode = useAppSelector(
    (state) => state.taskListPage.selectedGlobalMenuTaskListDisplayMode
  )

  // タスクリストの表示モードによって表示を切り替える
  const renderTaskList = useCallback(() => {
    switch (selectedTaskListDisplayMode) {
      case GlobalMenuTaskDisplayModeButtonGroup.List.id:
        return <TaskTable />
      case GlobalMenuTaskDisplayModeButtonGroup.Calendar.id:
        return <TaskCalendar />

      // TODO: 以下タスクで実装時に有効化する
      // https://break-tmc.atlassian.net/browse/CREW-20734
      // case GlobalMenuTaskDisplayModeButtonGroup.Gantt.id:
      //   // TODO: 以下で実装する
      //   // https://break-tmc.atlassian.net/browse/CREW-20734
      //   return null
      default:
        return null
    }
  }, [selectedTaskListDisplayMode])

  return renderTaskList()
})
